import { LOCALES } from 'i18n/locales';

export const warningTextIntl = {
    [LOCALES.ENGLISH]: {
        'warningText.warning': 'Warning '
    },
    [LOCALES.WELSH]: {
        'warningText.warning': 'Rhybudd '
    }
};
